module.exports = __webpack_public_path__ + "static/media/md-skip-backward.51eb1462.svg";